import { FC } from 'react'
import styles from './UnmatchedSleepEngineering.module.scss'
import { Img } from 'components/basic/Img/Img'

export const UnmatchedSleepEngineering: FC = () => {
	return (
		<section className={styles.root}>
			<div className={styles.content_container}>
				<div className={styles.title}>Unmatched sleep engineering for champions</div>
				<div className={styles.subtitle}>The Pod is the game-changer in sleep technology, embraced by the world's top athletes to power their sleep, recovery and performance.</div>
			</div>

			<div className={styles.image_container}>
				<Img
					src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes/unmatched-sleep-engineering.jpg"
					alt="unmatched sleep engineering"
				/>

				<div className={styles.fitness_score_container}>
					<div className={styles.fitness_score_ellipse_container}>
						<Img
							src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes/ellipse.png"
							alt="unmatched sleep engineering"
						/>

						<div className={styles.fitness_score_title_container}>
							<div className={styles.fitness_score_title_number}>100</div>
							<div className={styles.fitness_score_title_text}>Excellent</div>
						</div>
					</div>

					<div className={styles.fitness_score_subtitle}>Sleep Fitness Score</div>
				</div>

				<div className={styles.athlete_container}>
					<div className={styles.athlete_name}>Kristi O’Connell</div>
					<div className={styles.athlete_occupation}>CrossFit Athlete</div>
				</div>
			</div>
		</section>
	)
}
